import { Grid, CircularProgress, Typography } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';
import React, { useState, useEffect } from 'react';

const LivrosBiblioteca = () => {
  const [livros, setLivros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://cnm.org.br/api/biblioteca?limit=&area_tecnica=2&sort=created_at&order=desc&search=drogas');
        const data = await response.json();
        // console.log('Dados recebidos da API:', data); // Verifique se os dados são recebidos corretamente
        if (data.biblioteca && Array.isArray(data.biblioteca.data)) {
          // Filtrar livros publicados após 2017
          const filteredLivros = data.biblioteca.data.filter(livro => parseInt(livro.ano) > 2016);
          setLivros(filteredLivros);
        } else {
          setError('Os dados recebidos não estão no formato esperado');
        }
      } catch (error) {
        console.error('Erro ao buscar livros:', error);
        setError('Erro ao carregar os livros. Por favor, tente novamente mais tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const openPdf = (link) => {
    window.open(link, '_blank');
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '75vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '75vh', }}>
        <Typography variant="h6" color="error">{error}</Typography>
      </div>
    );
  }

  return (
    <Grid container style={{ minHeight: '75vh', justifyContent: 'center', padding: '20px', backgroundColor: '#E5EBEF' }}>
      <Typography  style={{ textAlign: 'center', paddingTop: '2em', fontSize: '2em', fontWeight: '600' }}>Biblioteca</Typography>
      <Grid container spacing={3}justify="center">
        {livros.map(livro => (
          <Grid item key={livro.id}>
            <img
              src={livro.imagem.trim() !== '' ? livro.imagem : 'https://cnm.org.br/img/img-padrao-biblioteca.jpg'}
              alt={livro.titulo}
              onClick={() => openPdf(`https://cnm.org.br${livro.link}`)}
              style={{ cursor: 'pointer', width: '220px', height: '300px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}
            />
            {/* <Typography variant="subtitle1" align="center" style={{ marginTop: '10px' }}>{livro.titulo}</Typography> */}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default LivrosBiblioteca;
